import { Line } from '@ant-design/plots';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import IconNoData from '../../../assets/Images/icons/icon-no-data';
import { Spin } from 'antd';
import { memo, useMemo } from 'react';

const Overview2 = memo(function Overview2({
    requestInfo,
    period,
    selectPeriod,
    year,
    isLoadingGraph,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;

    const config = useMemo(() => {
        return {
            data: requestInfo,
            xField: 'date',
            yField: 'value',
            // seriesField: 'type',
            smooth: true,
            color: '#2CD9C5',
            style: {
                cursor: 'pointer',
            },
            lineStyle: {
                lineWidth: 3,
            },
            legend: {
                layout: 'horizontal',
                marker: {
                    symbol: 'circle',
                },
            },
            interactions: [{ type: 'element-active' }],
            // type: 'marker-active',
            state: {
                active: {
                    animate: { duration: 100, easing: 'easeLinear' },
                    style: {
                        cursor: 'pointer',
                        lineWidth: 2,
                        stroke: '#000',
                    },
                },
            },
            xAxis: {
                label: {
                    autoRotate: true,
                    style: {
                        cursor: 'pointer',
                        fill: '#505D6F',
                        fontWeight: 600,
                        fontSize: 12,
                    },
                },
            },
            yAxis: {
                label: {
                    autoRotate: true,
                    style: {
                        cursor: 'pointer',
                        fill: '#505D6F',
                        fontWeight: 600,
                        fontSize: 12,
                    },
                },
            },
            tooltip: {
                customContent: (title, data) => {
                    const item = data[0]?.data;
                    return (
                        <>
                            {/* {console.log('tooltip ', title, data)} */}
                            <div className="p-3 text-xs font-semibold">
                                <div className="py-1 flex space-x-4">
                                    {period === 'Last 7 Days' && (
                                        <>
                                            {`${
                                                moment(item?.timeStamp)
                                                    .format(`D MMM YYYY`)
                                                    .split(' ')[0]
                                            } ${
                                                lang === 'en'
                                                    ? moment(item?.timeStamp)
                                                          .format(`D MMM YYYY`)
                                                          .split(' ')[1]
                                                    : findMonthName(
                                                          Number(
                                                              moment(
                                                                  item?.timeStamp
                                                              ).format(`M`)
                                                          )
                                                      )?.monthTh
                                            }
                                    ${
                                        moment(item?.timeStamp)
                                            .format(`D MMM YYYY`)
                                            .split(' ')[2]
                                    } 
                                    `}
                                        </>
                                    )}
                                    {period === 'Monthly' && (
                                        <>
                                            {/* {`${title?.split(' ')[0]} ${lang === 'en'
                                        ? findMonthName(selectPeriod)?.monthEn
                                        : findMonthName(selectPeriod)?.monthTh} ${date.getFullYear()}`} */}
                                            {`${
                                                moment(item?.timeStamp)
                                                    .format(`D MMM YYYY`)
                                                    .split(' ')[0]
                                            } ${
                                                lang === 'en'
                                                    ? moment(item?.timeStamp)
                                                          .format(`D MMM YYYY`)
                                                          .split(' ')[1]
                                                    : findMonthName(
                                                          selectPeriod
                                                      )?.monthTh
                                            }
                                    ${
                                        moment(item?.timeStamp)
                                            .format(`D MMM YYYY`)
                                            .split(' ')[2]
                                    } 
                                    `}
                                        </>
                                    )}
                                    {period === 'Yearly' && (
                                        <>
                                            {title} {year}
                                        </>
                                    )}
                                </div>
                                <div className="py-1 flex space-x-4">
                                    <div>
                                        <svg
                                            width="12"
                                            height="13"
                                            viewBox="0 0 12 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="6"
                                                cy="6.5"
                                                r="6"
                                                fill={`${data[0]?.color}`}
                                            />
                                        </svg>
                                    </div>
                                    {/* <div>{`${data[0]?.data?.type}`}</div> */}
                                    <div>
                                        {t('Dashboard360.ListOfRightsRequests')}
                                    </div>
                                    <div>{`${data[0]?.value}`}</div>
                                </div>
                            </div>
                        </>
                    );
                },
            },
        };
    }, [lang, period, requestInfo, selectPeriod, t, year]);

    const findMonthName = (value) => {
        return months?.find((e) => {
            return e.id === value;
        });
    };

    return (
        <Spin spinning={isLoadingGraph}>
            <div className="flex space-x-2 justify-between items-center pb-4">
                <div className="font-semibold text-lg">
                    {t('Dashboard360.ListOfRightsRequests')}{' '}
                    {period === 'Last 7 Days' && (
                        <>
                            {moment(new Date())
                                .subtract(6, 'days')
                                .format('DD/MM/YYYY')}{' '}
                            - {moment(new Date()).format('DD/MM/YYYY')}
                        </>
                    )}
                    {period === 'Monthly' && (
                        <>
                            {lang === 'en'
                                ? findMonthName(selectPeriod)?.monthEn
                                : findMonthName(selectPeriod)?.monthTh}
                        </>
                    )}
                    {period === 'Yearly' && (
                        <>
                            {lang === 'en'
                                ? `in ${selectPeriod}`
                                : `ปี ${selectPeriod}`}
                        </>
                    )}
                </div>
                <div className="flex items-center">
                    <svg
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="6" cy="6.5" r="6" fill="#2CD9C5" />
                    </svg>
                    <div className="pl-2 text-[13px]">
                        {t('Dashboard360.DataSubjectRightsRequest')}
                    </div>
                </div>
            </div>

            {requestInfo?.length <= 0 ? (
                <div className="text-center text-sm space-y-2 my-32">
                    <IconNoData />
                    <p className="text-[#65707A] text-[14px]">
                        {t('common.noData')}
                    </p>
                </div>
            ) : (
                <Line {...config} />
            )}
        </Spin>
    );
});

const months = [
    {
        id: 1,
        monthEn: 'January',
        monthTh: 'มกราคม',
    },
    {
        id: 2,
        monthEn: 'February',
        monthTh: 'กุมภาพันธ์',
    },
    {
        id: 3,
        monthEn: 'March',
        monthTh: 'มีนาคม',
    },
    {
        id: 4,
        monthEn: 'April',
        monthTh: 'เมษายน',
    },
    {
        id: 5,
        monthEn: 'May',
        monthTh: 'พฤษภาคม',
    },
    {
        id: 6,
        monthEn: 'June',
        monthTh: 'มิถุนายน',
    },
    {
        id: 7,
        monthEn: 'July',
        monthTh: 'กรกฎาคม',
    },
    {
        id: 8,
        monthEn: 'August',
        monthTh: 'สิงหาคม',
    },
    {
        id: 9,
        monthEn: 'September',
        monthTh: 'กันยายน',
    },
    {
        id: 10,
        monthEn: 'October',
        monthTh: 'ตุลาคม',
    },
    {
        id: 11,
        monthEn: 'November',
        monthTh: 'พฤศจิกายน',
    },
    {
        id: 12,
        monthEn: 'December',
        monthTh: 'ธันวาคม',
    },
];

export default Overview2;
